var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.982 9.99664C19.982 15.4921 15.5272 19.9469 10.0318 19.9469C4.53637 19.9469 0.081543 15.4921 0.081543 9.99664C0.081543 4.50121 4.53637 0.0463867 10.0318 0.0463867C15.5272 0.0463867 19.982 4.50121 19.982 9.99664Z",
    fill: "#1BA27A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7018 5.06396H5.27979V7.33849H8.85352V10.6818H11.128V7.33849H14.7018V5.06396Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0125 11.0378C7.05618 11.0378 4.65957 10.57 4.65957 9.99277C4.65957 9.41565 7.05618 8.94769 10.0125 8.94769C12.9687 8.94769 15.3653 9.41565 15.3653 9.99277C15.3653 10.57 12.9687 11.0378 10.0125 11.0378ZM16.0229 10.167C16.0229 9.42272 13.332 8.81934 10.0125 8.81934C6.693 8.81934 4.00195 9.42272 4.00195 10.167C4.00195 10.8223 6.08862 11.3684 8.8536 11.4895V16.2889H11.1281V11.4914C13.9145 11.3741 16.0229 10.8258 16.0229 10.167Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtIcon);
export default __webpack_public_path__ + "static/media/usdtIcon.bce045a673a67236276055f8b7307257.svg";
export { ForwardRef as ReactComponent };